/* 🤖 this file was generated by svg-to-ts */
export const iconWsteth: {
  name: 'wsteth';
  data: string;
} = {
  name: 'wsteth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M21.3 16.45 16 19.58l-5.31-3.13L16 26.12zm-9.7-3.22 4.41 2.56 4.42-2.54L16 10.81z"/><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-.03 4.77h.01s0-.02.02-.02h.04l5.65 8.67-.1.05-5.6 3.2-5.6-3.2s-.11-.04-.09-.05l5.65-8.67zm8.04 15.44a7.85 7.85 0 0 1-2.31 4.72 8.07 8.07 0 0 1-5.69 2.31c-2.15 0-4.17-.82-5.69-2.31a7.88 7.88 0 0 1-2.31-4.72c-.2-1.78.23-3.59 1.22-5.1l.18-.27 6.6 3.77 6.49-3.71s.11-.08.12-.07l.18.27a7.8 7.8 0 0 1 1.22 5.1z"/></svg>`,
};
